import React from "react";

export default function InfiniteScrollSentinel({
  sentinelRef,
  isLoading = false,
  hasMore = false,
  className = "",
}) {
  if (!hasMore && !isLoading) return null;

  return (
    <div
      ref={sentinelRef}
      className={`flex justify-center py-8 ${className}`.trim()}
      aria-hidden={!hasMore && !isLoading}
    >
      {isLoading && (
        <span className="text-[16px] text-[#6E7B86]">Loading more products…</span>
      )}
    </div>
  );
}
